import _forEach from 'lodash/forEach';
import _reduce from 'lodash/reduce';
import {CreativeTemplateDropDownOptions, DropDownOptionsKey} from '../creativeTemplates.types';

export default function mergeDropDownOptionsObjs(optionsList: CreativeTemplateDropDownOptions[]) {
  const [firstOptions, ...restOfOptions] = optionsList;

  return _reduce(
    restOfOptions,
    (mergedOptions, optionsObj) => {
      _forEach(Object.keys(optionsObj), (key: DropDownOptionsKey) => {
        mergedOptions[key] = [...mergedOptions[key], ...optionsObj[key]];
      });

      return mergedOptions;
    },
    {...firstOptions},
  );
}
